export default __webpack_public_path__ + "static/media/stake-hub.0d9b4da6.png";